import { Form, Modal, Spin, Select, DatePicker, InputNumber, Button, notification, Input } from 'antd'
import { withNamespaces } from 'react-i18next'
import { find, isEmpty, range } from 'lodash'
import CashRequestService from '../../../services/cashRequest.service'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { LocalStore } from '../../../utils/LocalStore'
import { PlusCircleOutlined } from '@ant-design/icons'

const CreateRequestCash = props => {
    const { isOpen, onClose, listAddress, currentUser, history, loadingAddress } = props
    const [loading, setLoading] = useState(false)
    const currentProjectInfo = LocalStore.getInstance().read('currentProjectInfo') || {}
    const [formRef] = Form.useForm()

    const disabledDateTime = () => {
        return {
            disabledHours: () => range(0, 8).concat(range(19, 24)), // Disable hours before 8 AM and after 6 PM
        }
    }
    const disabledDate = current => {
        // Can not select dates before today
        return current && current < moment().startOf('day')
    }

    useEffect(() => {
        if (Number(currentProjectInfo?.tenantConfig?.generalConfig?.cashCollectionConfig?.minAmount || 0) > 0) {
            formRef.setFieldValue(
                'amount',
                Number(currentProjectInfo?.tenantConfig?.generalConfig?.cashCollectionConfig?.minAmount || 0)
            )
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentProjectInfo])

    const addressId = Form.useWatch('addressId', formRef)

    const callCreateRequest = values => {
        setLoading(true)
        const findAddress = find(listAddress, { id: values?.addressId })
        const bodyData = {
            type: 'CUSTOMER_REQUEST_COLLECT_CASH',
            object: `m1:${currentUser?.username}`,
            name: `Khách ${currentUser?.username} yêu cầu lấy tiền mặt, số tiền ${Number(values?.amount)}`,
            start: values?.date?.startOf('hour').toISOString(),
            due: null,
            context: {
                address: findAddress,
            },
            notes: [values?.notes],
            customField01: Number(values?.amount),
            customField02: findAddress?.location?.id,
            customField03: `${findAddress?.detail}, ${findAddress?.location?.display}`,
        }
        CashRequestService.createCashRequest(bodyData, (error, response) => {
            if (!isEmpty(response)) {
                notification.success({
                    message: 'Thêm yêu cầu thu tiền mặt thành công',
                })
                onClose()
                setLoading(false)
            }
            if (!isEmpty(error)) {
                notification.error({
                    message: 'Thêm yêu cầu thu tiền mặt lỗi. Vui lòng thử lại',
                })
            }
        })
    }
    return (
        <Modal
            footer={null}
            title="Thêm yêu cầu thu tiền mặt"
            width={720}
            centered
            open={isOpen}
            destroyOnClose
            onCancel={() => onClose()}
        >
            <Spin spinning={loadingAddress}>
                <Form
                    form={formRef}
                    onFinish={callCreateRequest}
                    layout="vertical"
                >
                    <Form.Item
                        label="Số tiền"
                        name="amount"
                        rules={[
                            {
                                required: true,
                                message: 'Số tiền không được để trống',
                            },
                        ]}
                    >
                        <InputNumber
                            min={Number(currentProjectInfo?.tenantConfig?.generalConfig?.cashCollectionConfig?.minAmount || 0)}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            className="!w-full"
                            placeholder="Vui lòng nhập số tiền"
                        />
                    </Form.Item>
                    <Form.Item
                        label="Địa chỉ"
                        name="addressId"
                        rules={[
                            {
                                required: true,
                                message: 'Địa chỉ không được để trống',
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            options={
                                !isEmpty(listAddress)
                                    ? listAddress?.map(item => ({
                                          label: `${item?.detail}, ${item?.location?.display}`,
                                          value: item?.id,
                                      }))
                                    : []
                            }
                            filterOption={(input, option) => option?.label?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0}
                            optionFilterProp="children"
                            placeholder="Vui lòng chọn địa chỉ"
                        />
                    </Form.Item>
                    {addressId && (
                        <div>
                            Người liên hệ: {find(listAddress, { id: addressId })?.fullname} - SDT{' '}
                            {find(listAddress, { id: addressId })?.phone}
                        </div>
                    )}
                    <div className="flex justify-end">
                        <Button
                            type="default"
                            icon={<PlusCircleOutlined />}
                            onClick={() => history.push('/profile/address')}
                        >
                            Thêm địa chỉ
                        </Button>
                    </div>
                    <Form.Item
                        label="Thời gian lấy"
                        placeholder="Vui lòng chọn thời gian lấy"
                        name="date"
                        rules={[
                            {
                                required: true,
                                message: 'Thời gian lấy không được để trống',
                            },
                        ]}
                    >
                        <DatePicker
                            showTime
                            disabledTime={disabledDateTime}
                            format={'DD/MM/YYYY HH'}
                            className="!w-full"
                            disabledDate={disabledDate}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Ghi chú"
                        name="notes"
                    >
                        <Input.TextArea rows={3} />
                    </Form.Item>

                    <div className="flex gap-x-2 justify-end">
                        <Button
                            onClick={() => onClose()}
                            type="default"
                        >
                            Hủy
                        </Button>
                        <Button
                            loading={loading}
                            htmlType="submit"
                            type="primary"
                        >
                            Thêm
                        </Button>
                    </div>
                </Form>
            </Spin>
        </Modal>
    )
}
export default withNamespaces()(CreateRequestCash)
